import { useMenuDelete } from 'components/menu/model/useMenuDelete';
import * as React from 'react';

export function useMenuOptionsDeleteControls(readyToSave: boolean, handleCancel: () => void) {
    const { deleted, resetDeleted, isCellEditable } = useMenuDelete();

    const editedOrDeleted = React.useMemo(
        () => readyToSave || deleted?.size > 0,
        [readyToSave, deleted?.size]
    );

    const handleCancelEditing = React.useCallback(() => {
        resetDeleted();
        handleCancel();
    }, [handleCancel, resetDeleted]);

    return {
        deleted,
        editedOrDeleted,
        handleCancelEditing,
        isCellEditable,
        resetDeleted
    };
}
